import { Injectable, inject } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ApiService } from '../../services/api';
import { FetchBrands, SetSelectedBrand, FetchAllCurrency } from './actions';
import { ROUTES_CONFIG } from '@core';
import { tap } from 'rxjs/operators';
import { CONSTANT } from '../../constant';

@State<any>({
	name: 'app',
	defaults: {}
})

@Injectable()
export class AppState {
	private _api = inject(ApiService);


  @Action(FetchBrands, { cancelUncompleted: true })
	onFetchBrands(
		{ setState, getState }: StateContext<any>,
		{ payload }: FetchBrands
	): any {
		const API_URL = ROUTES_CONFIG.GET_BRAND;
		return this._api.get(API_URL, {
			params: payload
		}).pipe(
			tap((res: any) => {
				if (res?.status?.toLowerCase() === 'success') {
					const seletedBrand = res.brands.find(brand => brand.selected) || res.brands[0] || {};
					setState({
						...getState(),
						brands: {
							list: [...res.brands],
							selected: seletedBrand
						}
					})
				}
			})
		)
	}

  @Action(SetSelectedBrand, { cancelUncompleted: true })
  onSetSelectedBrand(
  	{ setState, getState }: StateContext<any>,
  	{ payload }: SetSelectedBrand
  ): any {
  	if (!payload) {
  		setState({
  			...getState(),
  			brands: null
  		})
  		return;
  	}
  	let stateData: any = {
  		selected: payload
  	};
  	if (payload?.type?.toLowerCase() === CONSTANT.ORG_BRAND.toLowerCase()) {
  		stateData = {
  			...stateData,
  			list: [payload]
  		}
  	}
  	setState({
  		...getState(),
  		brands: {
  			...getState().brands,
  			...stateData
  		}
  	})
  }

  @Action(FetchAllCurrency, { cancelUncompleted: true })
  onFetchAllCurrency(
  	{ setState, getState }: StateContext<any>,
  	{ payload }: FetchAllCurrency
  ): any {
  	const API_URL = ROUTES_CONFIG.FETCH_ALL_CURRENCY;
  	return this._api.get(API_URL, {
  		params: payload
  	}).pipe(
  		tap((res: any) => {
  			if (res?.status?.toLowerCase() === 'success') {
  				setState({
  					...getState(),
  					currency: {
  						list: [...res.data],
  						base_code: res.base_code
  					}
  				})
  			}
  		})
  	)
  }
}
